import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { crowdfundAPI } from '../services/api';
import { Heart, ArrowRight } from '@phosphor-icons/react';

export default function CrowdfundHero({ compact = false }) {
  const [data, setData] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await crowdfundAPI.getCampaign();
        setData(data);
      } catch (err) {
        console.error('Failed to load crowdfund campaign (hero hidden):', err);
      }
    })();
  }, []);

  if (!data || !data.active) return null;

  const pct = Math.min(data.progress_pct || 0, 100);

  return (
    <section className={`${compact ? 'py-12' : 'py-20'} bg-[#0A0A0A] border-y border-[#22C55E]/20`} data-testid="crowdfund-hero">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <div className="bg-gradient-to-br from-[#0D1F17] to-[#111111] border border-[#22C55E]/30 rounded-2xl p-8 sm:p-10">
          <div className="flex items-center gap-2 mb-4">
            <Heart className="w-4 h-4 text-[#22C55E]" weight="fill" />
            <span className="text-xs tracking-[0.2em] uppercase font-semibold text-[#22C55E]">Back the Future</span>
          </div>
          <h2 className="text-2xl sm:text-4xl font-bold tracking-tight text-white mb-3" style={{ fontFamily: 'Cabinet Grotesk' }}>
            {data.title}
          </h2>
          <p className="text-[#999] max-w-xl mb-8">{data.tagline}</p>

          {/* Progress */}
          <div className="mb-6">
            <div className="flex items-baseline justify-between mb-2">
              <span className="text-3xl sm:text-4xl font-bold text-white" style={{ fontFamily: 'Cabinet Grotesk' }}>
                ${(data.raised || 0).toLocaleString()}
                <span className="text-base text-[#666] font-normal ml-2">of ${(data.goal || 0).toLocaleString()}</span>
              </span>
              <span className="text-sm text-[#22C55E] font-semibold">{pct}%</span>
            </div>
            <div className="h-2.5 bg-[#1a1a1a] rounded-full overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-[#22C55E] to-[#16A34A] rounded-full transition-all duration-700"
                style={{ width: `${pct}%` }}
                data-testid="crowdfund-progress-bar"
              />
            </div>
            <div className="flex items-center gap-4 mt-3 text-xs text-[#999]">
              <span><strong className="text-white">{data.backers || 0}</strong> backers</span>
              {data.deadline && <span>Ends {new Date(data.deadline).toLocaleDateString()}</span>}
            </div>
          </div>

          <Link to="/back-us">
            <Button className="bg-[#22C55E] hover:bg-[#16A34A] text-white rounded-sm h-12 px-6 text-base font-semibold" data-testid="back-us-cta">
              Back Divispend <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
